import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {RoomClosure} from '../classes/RoomClosure';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root'
})
export class RoomClosureService {
  constructor(private httpClient: HttpClient) { }

  public getAll(): Observable<RoomClosure[]> {
    return this.httpClient.get<RoomClosure[]>(`${environment.backendApiUrl}/v1/roomclosures`, httpOptions);
  }

  public addOrEdit(roomClosure: any): Observable<void> {
    return this.httpClient.put<void>(`${environment.backendApiUrl}/v1/roomclosures`, roomClosure, httpOptions);
  }

  public delete(id: number): Observable<void> {
    return this.httpClient.delete<void>(`${environment.backendApiUrl}/v1/roomclosures/` + id, httpOptions);
  }
}
